
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 500 500","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.069 405.622c0 15.223 6.024 29.83 16.791 40.56 10.765 10.757 25.348 16.825 40.57 16.825h344.186c15.22 0 29.791-6.068 40.558-16.825a57.288 57.288 0 0016.827-40.56V161.844a57.356 57.356 0 00-16.827-40.569c-10.767-10.762-25.338-16.819-40.558-16.819H278.551c-51.09 0-43.006-71.699-121.007-71.699H63.43c-15.222 0-29.805 6.068-40.57 16.791A57.367 57.367 0 006.069 90.116v315.506z","fill":"#8486D3"}}),_c('path',{attrs:{"d":"M436.297 133.129h-94.085c-77.999 0-69.959 71.737-121.009 71.737H92.114a57.406 57.406 0 00-40.574 16.791 57.323 57.323 0 00-16.79 40.561v143.404c0 3.806-1.5 7.454-4.197 10.145a14.311 14.311 0 01-10.145 4.221 14.355 14.355 0 01-10.145-4.221 14.333 14.333 0 01-4.194-10.145c0 15.223 6.024 29.83 16.791 40.56 10.765 10.757 25.348 16.825 40.57 16.825h372.867c15.224 0 29.799-6.068 40.557-16.825a57.296 57.296 0 0016.826-40.56V190.525a57.358 57.358 0 00-16.826-40.569 57.337 57.337 0 00-40.557-16.827z","fill":"#C0C2FF"}})])
          )
        }
      }
    